module.exports = __webpack_public_path__ + "static/img/space2.181e5176.png";